<template>
<!-- FIXME: 如果父组件高度未占满屏幕,在IOS中可能出现适配问题 -->
  <div class="xt-dialog__wrapper" v-show="visible">
    <transition name="dialog">
      <div v-show="visible">
        <div class="xt-dialog" :class="{'no-button': noButton}" :style="dialogStyle">
          <div class="xt-dialog__title">{{ title }}</div>
          <slot/>
          <div class="xt-dialog__buttons" v-if="!noButton">
            <template v-if="type=== 'confirm'">
              <div :style="disCancel ? '':'color:#497AC0'" @click="handleCancel" class="xt-dialog__button-left xt-dialog__button">{{ cancelText }}</div>
              <div :style="disConfirm ? 'color:#999;':''" @click="handleConfirm" class="xt-dialog__button-right xt-dialog__button">{{ confirmText }}</div>
            </template>
            <div @click="handleConfirm" class="xt-dialog__button" style="cursor:pointer;" v-else>{{ confirmText }}</div>
          </div>
        </div>
        <div @click="handleCancel" class="xt-dialog__close" v-if="noButton && !noClose">
          <div class="xt-dialog__close_line left"></div>
          <div class="xt-dialog__close_line right"></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '提交'
    },
    // confirm, alert
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: '提示'
    },
    noButton: {
      type: Boolean,
      default: false
    },
    noClose: {
      type: Boolean,
      default: false
    },
    dialogStyle: {
      type: String
    },
    visible: {
      type: Boolean,
      default: true
    },
    disConfirm: {
      type: Boolean,
      default: false
    },
    disCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handling: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleConfirm() {
      if (!this.disConfirm){
        this.$emit('confirm')
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '../css/mobile.less';

.xt-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 99999999999;
  margin: 0;
  background: rgba(0, 0, 0, 0.75);
  transform: translateZ(100px);
  height: 100vh;

  .xt-dialog {
    margin-top: 20vh;
    margin-left: auto;
    margin-right: auto;
    width: 350px;
    min-height: 100px;
    border-radius: 10px;
    background: #FFF;
    box-sizing: border-box;
    padding: 26px 12px 45px 12px;
    overflow: hidden;
    position: relative;

    &.no-button {
      padding-bottom: 28px;
    }

    .xt-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: 500;
    }

    .xt-dialog__buttons {
      border-top: 1px solid #CECECE;
      width: 100%;
      height: 45px;
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;

      .xt-dialog__button {
        width: 100%;
        margin: 0;
        padding: 0;
        line-height: 45px;
        text-align: center;
        color: #497AC0;
        font-size: 16px;

        &:active {
          color: @primary-color;
        }

        &.xt-dialog__button-left {
          border-right: 1px solid #CECECE;
          width: 50%;
          color: #999;

          &.active {
            color: #AAA;
          }
        }

        &.xt-dialog__button-right {
          width: 50%;
        }
      }
    }
  }

  .xt-dialog__close {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid #BBB;

    .xt-dialog__close_line {
      background: #FFF;
      width: 20px;
      height: 1px;
      position: relative;
      top: 17px;
      left: 8px;

      &.left {
        transform: rotateZ(45deg);
      }

      &.right {
        transform: rotateZ(315deg);
      }
    }
  }
}

@keyframes rise {
  from {
    opacity: .4;
    transform: scale(.7);
  }
}
@keyframes visible {
  from {
    opacity: .4;
  }
}
.dialog-enter-active{
  animation: rise .2s;
}
.wrapper-enter-active{
  animation: visible .2s;
}
</style>
